export interface IMarkerFactory {
  createMarker(map: google.maps.Map | undefined, latitude: number, longitude: number, data: any): Promise<google.maps.marker.AdvancedMarkerElement>;
}

export abstract class BaseMarkerFactory implements IMarkerFactory {
  private static markerLibPromise: Promise<google.maps.MarkerLibrary> | null = null;

  protected abstract createMarkerDiv(data: any): HTMLDivElement;

  protected abstract createTitle(data: any): string;

  async createMarker(map: google.maps.Map | undefined, latitude: number, longitude: number, data: any): Promise<google.maps.marker.AdvancedMarkerElement> { 
    // @ts-ignore
    const { AdvancedMarkerElement } = await BaseMarkerFactory.getMarkerLib();
    return new AdvancedMarkerElement({
      position: { lat: latitude, lng: longitude },
      // map: map,
      content: this.createMarkerDiv(data),
      title: this.createTitle(data)
    });
  }

  private static async getMarkerLib(): Promise<google.maps.MarkerLibrary> {
    if (!this.markerLibPromise) {
      this.markerLibPromise = google.maps.importLibrary('marker') as Promise<google.maps.MarkerLibrary>;
    }
    return this.markerLibPromise;
  }
}